// ui
export const LOADING_START = "LOADING_START";
export const LOADING_STOP  = "LOADING_STOP";
export const MODAL_INIT    = "MODAL_INIT";
export const MODAL_OPEN    = "MODAL_OPEN";
export const MODAL_CLOSE   = "MODAL_CLOSE";

export const SET_UPLOAD_PROGRESS = "SET_UPLOAD_PROGRESS"

// selectOptions
export const COMPANY_MONTHLY_FETCH_SUCCESS = "COMPANY_MONTHLY_FETCH_SUCCESS";

// notices
export const HANDLE_ERRORS = "HANDLE_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SESSION_EXPIRE = "SESSION_EXPIRE";
export const NOTIFY_UPDATE = "NOTIFY_UPDATE";
export const SET_RCL_NOTIFICATION = 'SET_RCL_NOTIFICATION';
export const OPEN_BANNER = 'OPEN_BANNER';
export const CLOSE_BANNER = "CLOSE_BANNER";
export const TOGGLE_BANNER = 'TOGGLE_BANNER';

// generic notification
export const NOTIFY = "NOTIFY";
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";

// routes
export const SET_SOURCE_ROUTE = "SET_SOURCE_ROUTE";
export const RESET_SOURCE_ROUTE = "RESET_SOURCE_ROUTE";



// WEBPACK FOOTER //
// ./src/features/shared/actionTypes.js